import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  extendedWarrantyFromModel,
  validateExtendedWarrantyCondition,
  type ExtendedWarrantyState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const EXTENDED_WARRANTY = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ExtendedWarrantyState>
  >,
): ConditionType<ExtendedWarrantyState, Condition.ExtendedWarranty> => ({
  name: CONDITION_NAMES[Condition.EXTENDED_WARRANTY],
  description() {
    return t("Extended warranty is live on item");
  },
  Details(props: ConditionTypeDetailsProps<ExtendedWarrantyState>) {
    return React.createElement(Details, props);
  },
  empty: {},
  fromModel(model) {
    return extendedWarrantyFromModel(model);
  },
  toModel(state) {
    return { type: Condition.EXTENDED_WARRANTY };
  },
  valid(state) {
    return validateExtendedWarrantyCondition(state).valid;
  },
});
